import { EventEmitter, Injectable } from '@angular/core';
import { PageFilter } from '../models/shared/pageFilter';

@Injectable({ providedIn: 'root' })
export class EventService {
  static pageFilters = new EventEmitter<PageFilter>();

  static resetForm = new EventEmitter<void>();

  static changeCer = new EventEmitter<number>();

  static changeSite = new EventEmitter<number>();
}
